import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getLimitsStore = (state: RootState) => state.limitsStore;
const getClientsReachingLimits = createSelector(getLimitsStore, ({ clientsReachingLimits }) => clientsReachingLimits);
const getClientsReachingLimitsCount = createSelector(getLimitsStore, ({ clientsReachingLimitsCount   }) => clientsReachingLimitsCount);
export { getClientsReachingLimits, getClientsReachingLimitsCount };
